import { render, staticRenderFns } from "./mediaPublishPreWaterUpload.vue?vue&type=template&id=108ff062&scoped=true&"
import script from "./mediaPublishPreWaterUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishPreWaterUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishPreWaterUpload.vue?vue&type=style&index=0&id=108ff062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108ff062",
  null
  
)

component.options.__file = "mediaPublishPreWaterUpload.vue"
export default component.exports